import { useState } from 'react';
import DemoBookingModal from './DemoBookingModal';

const HOURS = [
  '08:00','09:00','10:00','11:00','12:00','13:00',
  '14:00','15:00','16:00','17:00','18:00','19:00',
  '20:00','21:00','22:00',
];

const TAKEN = {
  0: { cancha1: ['09:00','10:00','14:00','18:00','19:00'], cancha2: ['08:00','11:00','15:00','20:00'] },
  1: { cancha1: ['08:00','12:00','17:00','21:00'],          cancha2: ['09:00','10:00','18:00','22:00'] },
  2: { cancha1: ['10:00','11:00','19:00','20:00'],          cancha2: ['08:00','14:00','15:00','21:00'] },
  3: { cancha1: ['09:00','13:00','18:00','22:00'],          cancha2: ['10:00','11:00','17:00','20:00'] },
  4: { cancha1: ['08:00','09:00','20:00','21:00'],          cancha2: ['12:00','13:00','18:00','19:00'] },
  5: { cancha1: ['10:00','14:00','15:00','19:00'],          cancha2: ['08:00','09:00','16:00','22:00'] },
  6: { cancha1: ['11:00','12:00','17:00','20:00'],          cancha2: ['10:00','14:00','19:00','21:00'] },
};

function getWeekDays(baseDate) {
  const days = [];
  const start = new Date(baseDate);
  start.setDate(start.getDate() - start.getDay() + 1); // lunes
  for (let i = 0; i < 7; i++) {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    days.push(d);
  }
  return days;
}

const DAY_NAMES = ['Lun','Mar','Mié','Jue','Vie','Sáb','Dom'];
const MONTH_NAMES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

export default function CanchaDemo() {
  const today = new Date();
  const [selectedDate, setSelectedDate] = useState(today);
  const [weekBase, setWeekBase] = useState(today);
  const [selected,   setSelected]   = useState({ cancha1: null, cancha2: null });
  const [modalOpen,  setModalOpen]  = useState(false);
  const [modalLabel, setModalLabel] = useState('');

  const weekDays = getWeekDays(weekBase);
  const dayIndex = selectedDate.getDay() === 0 ? 6 : selectedDate.getDay() - 1;
  const takenToday = TAKEN[dayIndex] || { cancha1: [], cancha2: [] };

  const toggleSlot = (cancha, hour) => {
    if (takenToday[cancha].includes(hour)) return;
    setSelected(prev => ({
      ...prev,
      [cancha]: prev[cancha] === hour ? null : hour,
    }));
  };

  const prevWeek = () => {
    const d = new Date(weekBase);
    d.setDate(d.getDate() - 7);
    setWeekBase(d);
  };

  const nextWeek = () => {
    const d = new Date(weekBase);
    d.setDate(d.getDate() + 7);
    setWeekBase(d);
  };

  const isSameDay = (a, b) =>
    a.getDate() === b.getDate() &&
    a.getMonth() === b.getMonth() &&
    a.getFullYear() === b.getFullYear();

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '24px 16px' }}>

      {/* HEADER NEGOCIO */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 18,
        background: 'var(--surface)', border: '1px solid var(--border)',
        borderRadius: 'var(--r-xl)', padding: '24px 28px', marginBottom: 28,
        boxShadow: 'var(--shadow)',
      }}>
        <div style={{
          width: 60, height: 60, borderRadius: 'var(--r-lg)',
          background: 'var(--green-bg)', border: '1px solid var(--green-border)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 28, flexShrink: 0,
        }}>⚽</div>
        <div style={{ flex: 1 }}>
          <div style={{
            fontFamily: 'var(--font-head)', fontSize: '1.4rem',
            fontWeight: 800, color: 'var(--text-primary)', letterSpacing: '-0.03em',
          }}>Los Manza</div>
          <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginTop: 3 }}>
            Canchas de fútbol 5 · Berazategui, Buenos Aires
          </div>
        </div>
        <div style={{ display: 'flex', gap: 20, textAlign: 'center' }}>
          {[['2', 'canchas'], ['60 min', 'por turno'], ['$36.000', 'por hora']].map(([val, lbl]) => (
            <div key={lbl}>
              <div style={{ fontFamily: 'var(--font-head)', fontWeight: 800, fontSize: '1.1rem', color: 'var(--green-light)' }}>{val}</div>
              <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>{lbl}</div>
            </div>
          ))}
        </div>
      </div>

      {/* SELECTOR DE SEMANA */}
      <div style={{
        background: 'var(--surface)', border: '1px solid var(--border)',
        borderRadius: 'var(--r-lg)', padding: '20px 24px', marginBottom: 24,
        boxShadow: 'var(--shadow)',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <button onClick={prevWeek} style={navBtnStyle}>← Anterior</button>
          <span style={{ fontFamily: 'var(--font-head)', fontWeight: 700, color: 'var(--text-primary)', fontSize: '0.95rem' }}>
            {MONTH_NAMES[weekDays[0].getMonth()]} {weekDays[0].getFullYear()}
          </span>
          <button onClick={nextWeek} style={navBtnStyle}>Siguiente →</button>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: 8 }}>
          {weekDays.map((d, i) => {
            const isToday = isSameDay(d, today);
            const isSel = isSameDay(d, selectedDate);
            return (
              <button
                key={i}
                onClick={() => { setSelectedDate(d); setSelected({ cancha1: null, cancha2: null }); }}
                style={{
                  display: 'flex', flexDirection: 'column', alignItems: 'center',
                  gap: 4, padding: '10px 4px', borderRadius: 'var(--r-md)',
                  border: isSel ? '2px solid var(--green)' : '1px solid var(--border)',
                  background: isSel ? 'var(--green-bg)' : isToday ? 'var(--bg3)' : 'transparent',
                  cursor: 'pointer', transition: 'all .18s',
                }}
              >
                <span style={{ fontSize: 11, color: 'var(--text-muted)', fontWeight: 600, letterSpacing: '.06em' }}>
                  {DAY_NAMES[i]}
                </span>
                <span style={{
                  fontFamily: 'var(--font-head)', fontWeight: 700, fontSize: '1.1rem',
                  color: isSel ? 'var(--green-light)' : 'var(--text-primary)',
                }}>
                  {d.getDate()}
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {/* FECHA SELECCIONADA */}
      <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 10 }}>
        <span style={{
          background: 'var(--green-bg)', border: '1px solid var(--green-border)',
          borderRadius: 'var(--r-full)', padding: '4px 14px',
          fontSize: 12.5, fontWeight: 700, color: 'var(--green-light)', letterSpacing: '.01em',
        }}>
          {DAY_NAMES[dayIndex]} {selectedDate.getDate()} de {MONTH_NAMES[selectedDate.getMonth()]}
        </span>
        <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>
          {HOURS.length - takenToday.cancha1.length + HOURS.length - takenToday.cancha2.length} turnos disponibles
        </span>
      </div>

      {/* GRILLA DE CANCHAS */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 24 }}>
        {['cancha1', 'cancha2'].map((cancha, ci) => (
          <div key={cancha} style={{
            background: 'var(--surface)', border: '1px solid var(--border)',
            borderRadius: 'var(--r-xl)', padding: '24px', boxShadow: 'var(--shadow)',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 18 }}>
              <div style={{
                width: 36, height: 36, borderRadius: 'var(--r-md)',
                background: 'var(--green-bg)', border: '1px solid var(--green-border)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16,
              }}>🏟️</div>
              <div>
                <div style={{ fontFamily: 'var(--font-head)', fontWeight: 700, fontSize: '0.95rem', color: 'var(--text-primary)' }}>
                  Cancha {ci + 1}
                </div>
                <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>Fútbol 5 · Césped sintético</div>
              </div>
              <div style={{
                marginLeft: 'auto', background: 'var(--green-bg)',
                border: '1px solid var(--green-border)', color: 'var(--green-light)',
                borderRadius: 'var(--r-full)', padding: '2px 10px', fontSize: 11, fontWeight: 600,
              }}>
                {HOURS.length - takenToday[cancha].length} libres
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
              {HOURS.map(hour => {
                const taken = takenToday[cancha].includes(hour);
                const isSel = selected[cancha] === hour;
                return (
                  <button
                    key={hour}
                    onClick={() => toggleSlot(cancha, hour)}
                    disabled={taken}
                    style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                      padding: '10px 14px', borderRadius: 'var(--r-md)',
                      border: isSel
                        ? '2px solid var(--green)'
                        : taken
                        ? '1px solid var(--border)'
                        : '1px solid var(--border)',
                      background: isSel ? 'var(--green-bg)' : taken ? 'transparent' : 'transparent',
                      cursor: taken ? 'not-allowed' : 'pointer',
                      opacity: taken ? 0.4 : 1,
                      transition: 'all .15s',
                    }}
                    onMouseEnter={e => { if (!taken && !isSel) e.currentTarget.style.borderColor = 'var(--green-light)'; }}
                    onMouseLeave={e => { if (!taken && !isSel) e.currentTarget.style.borderColor = 'var(--border)'; }}
                  >
                    <span style={{
                      fontFamily: 'var(--font-head)', fontWeight: 600, fontSize: '0.9rem',
                      color: isSel ? 'var(--green-light)' : 'var(--text-primary)',
                      textDecoration: taken ? 'line-through' : 'none',
                    }}>
                      {hour}
                    </span>
                    <span style={{
                      fontSize: 11, fontWeight: 600,
                      color: taken ? 'var(--text-muted)' : isSel ? 'var(--green-light)' : 'var(--text-secondary)',
                      background: taken ? 'transparent' : isSel ? 'var(--green-bg)' : 'var(--bg3)',
                      border: `1px solid ${taken ? 'transparent' : isSel ? 'var(--green-border)' : 'var(--border)'}`,
                      borderRadius: 'var(--r-full)', padding: '2px 9px',
                    }}>
                      {taken ? 'Ocupado' : isSel ? 'Seleccionado' : 'Libre'}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      {/* BARRA DE CONFIRMACION */}
      {(selected.cancha1 || selected.cancha2) && (
        <div style={{
          position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
          background: 'var(--surface)', border: '1px solid var(--green)',
          borderRadius: 'var(--r-xl)', padding: '16px 28px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.35)',
          display: 'flex', alignItems: 'center', gap: 20, zIndex: 200,
          backdropFilter: 'blur(16px)',
        }}>
          <div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 3 }}>Tu selección</div>
            <div style={{ fontFamily: 'var(--font-head)', fontWeight: 700, color: 'var(--text-primary)', fontSize: '0.95rem' }}>
              {selected.cancha1 && `Cancha 1 · ${selected.cancha1}`}
              {selected.cancha1 && selected.cancha2 && '  ·  '}
              {selected.cancha2 && `Cancha 2 · ${selected.cancha2}`}
            </div>
          </div>
          <button
            onClick={() => {
              const parts = [];
              if (selected.cancha1) parts.push(`Cancha 1 · ${selected.cancha1} hs`);
              if (selected.cancha2) parts.push(`Cancha 2 · ${selected.cancha2} hs`);
              setModalLabel(parts.join('  ·  '));
              setModalOpen(true);
            }}
            style={{
              background: 'var(--green)', color: '#fff', border: 'none',
              padding: '10px 24px', borderRadius: 'var(--r-full)',
              fontFamily: 'var(--font-body)', fontWeight: 700, fontSize: '0.9rem',
              cursor: 'pointer',
            }}
          >
            Reservar turno
          </button>
          <button
            onClick={() => setSelected({ cancha1: null, cancha2: null })}
            style={{
              background: 'transparent', border: '1px solid var(--border)',
              color: 'var(--text-muted)', borderRadius: 'var(--r-full)',
              padding: '9px 16px', cursor: 'pointer', fontSize: '0.85rem',
            }}
          >
            Cancelar
          </button>
        </div>
      )}

      <DemoBookingModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        booking={modalLabel}
      />
    </div>
  );
}

const navBtnStyle = {
  background: 'transparent', border: '1px solid var(--border)',
  color: 'var(--text-secondary)', borderRadius: 'var(--r-full)',
  padding: '6px 14px', cursor: 'pointer', fontSize: 13, fontWeight: 500,
};
